import React from "react";
import WidgetContainer from "components/WidgetContainer/WidgetContainer";

import "./InThePressArchives.css";

const InThePressArchives = () => {
    return (
        <WidgetContainer stylesClass="itp">
            <div className="itp-archive">
                <div className="itp-archive__title">Archives</div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.businessinsider.in/advertising/brands/article/phonepes-new-campaign-featuring-aamir-khan-and-alia-bhatt-showcases-the-ease-of-buying-insurance-on-the-platform/articleshow/87331947.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>28 October</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe's new campaign featuring Aamir Khan and
                                Alia Bhatt showcases the ease of buying
                                insurance on the platform
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Digital payments company PhonePe's latest brand
                                campaign 'Tension chhodo, Insurance lo',
                                featuring actors...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Insider</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.business-standard.com/article/companies/total-value-of-transactions-grew-23-3-qoq-to-rs-921-674-cr-phonepe-pulse-121101900467_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>19 October</p>
                            <h2 className="itp-archive__card-container__card__title">
                                Total value of transactions grew 23.3% QoQ to Rs
                                921,674 cr: PhonePe Pulse
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                The total payments value (TPV) of transactions
                                processed grew 23.3 per cent Quarter-on-Quarter
                                (QoQ) to Rs 9,21,674 crore while the number of
                                transactions grew by 33.6 per cent...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://timesofindia.indiatimes.com/business/india-business/phonepe-launches-silver-investments-option-on-its-app/articleshow/86609595.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>29 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe launches silver investment option on its
                                app
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Digital payments platform PhonePe announced on
                                Wednesday the launch of its new feature to
                                facilitate payments to buy silver coins and
                                bars...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Times of India</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://economictimes.indiatimes.com/tech/technology/phonepe-corners-nearly-half-of-all-transactions-on-bbps/articleshow/86469316.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>24 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe corners nearly half of all transactions
                                on BBPS
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                The Bengaluru-based fintech startup processed 28
                                million customer transactions worth Rs 4,039
                                crore in the month...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Economic Times</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.news18.com/amp/news/tech/phonepe-clocks-1-million-autopay-mandates-on-upi-in-just-three-months-4179677.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>08 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe Clocks 1 Million Autopay Mandates on UPI
                                in Just Three Months
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                PhonePe has announced that it registered over
                                one million UPI-enabled AutoPay mandates since
                                the feature debuted in June this year.
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>News18</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://yourstory.com/2021/09/fintech-startup-phonepe-launches-pulse-data-digital-payments-india/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>02 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                Fintech startup PhonePe unveils data repository
                                of Indian digital payments trends
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                PhonePe Pulse is the homegrown fintech startup's
                                latest endeavour to help shine more light on the
                                state of affairs in India's...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>YourStory</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.livemint.com/companies/news/phonepe-gets-irdai-license-to-serve-as-direct-insurance-broker-11630310542840.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>30 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe gets IRDAI license to serve as direct
                                insurance broker
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Digital payments platform PhonePe said on Monday
                                it has been issued an insurance broking license
                                from the Insurance...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Livemint</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://timesofindia.indiatimes.com/business/india-business/phonepe-gets-nod-as-a/c-aggregator/articleshow/85670717.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>27 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe gets nod as account aggregator
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Walmart-owned PhonePe has said that its wholly
                                owned subsidiary has received an in-principle
                                approval to operate as an account aggregator.
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Times of India</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.news18.com/news/tech/phonepe-now-offers-fastag-recharges-with-26-partnered-banks-how-to-use-4117187.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>23 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe Now Offers FASTag Recharges With 26
                                Partnered Banks: How to Use
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Digital payments platform PhonePe has announced
                                that the platform now offers lets users recharge
                                FASTag directly with 26 partnered banks.
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>News18</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://cio.economictimes.indiatimes.com/news/strategy-and-management/how-phonepes-head-of-cx-improving-customer-journeys/85027391"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>04 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                How PhonePe’s head of CX is improving customer
                                journeys
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Digital payments provider PhonePe currently has
                                over 307 million registered users. The company
                                is processing...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>ETCIO</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.thehindubusinessline.com/money-and-banking/phonepe-launches-upi-based-autopay-functionality-for-mutual-fund-sip-investments/article35677906.ece"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>02 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe launches UPI-based AutoPay functionality
                                for mutual fund SIP investments
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Homegrown digital payments platform PhonePe on
                                Monday announced the launch of UPI based AutoPay
                                functionality for its mutual...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Line</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://timesofindia.indiatimes.com/business/india-business/phonepe-to-help-digitise-cash-on-delivery-orders-on-flipkart/articleshow/84136396.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>05 July</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe to help digitise cash-on-delivery orders
                                on Flipkart
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Digital payments platform PhonePe has partnered
                                with Flipkart to launch contactless scan and pay
                                for Flipkart’s cash-on-delivery
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Times of India</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://gadgets.ndtv.com/apps/news/phonepe-online-payments-platform-co-founder-rahul-chari-indian-startups-101-2470274"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>23 June</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe on Adding Nearly 45 Million Monthly
                                Active Users in COVID-Hit 2020
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                PhonePe was one of the big winners of the
                                digitisation wave that was propelled by
                                demonetisation...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Gadgets 360</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.business-standard.com/article/companies/phonepe-launches-auto-top-up-feature-for-its-wallet-121061801357_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>18 June</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe launches auto top-up feature for its
                                wallet
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Walmart backed PhonePe on Friday said it has
                                launched an auto top-up feature for...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://yourstory.com/2021/06/phonepe-covid19-initiatives-for-employees-vaccination/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>07 June</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe's COVID-19 relief for employees: Rs 2L
                                allowance, additional leaves, mental health
                                support, and more
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Homegrown fintech giant PhonePe has undertaken
                                several employee welfare measures to help...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>YourStory</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.business-standard.com/article/companies/walmart-s-phonepe-crosses-300-mn-registered-users-merchant-network-grows-121060201035_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>02 June</p>
                            <h2 className="itp-archive__card-container__card__title">
                                Walmart's PhonePe crosses 300 mn registered
                                users, merchant network grows
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                Walmart-owned digital payments firm PhonePe said
                                it has crossed the 300 million lifetime
                                registered users milestone
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://hr.economictimes.indiatimes.com/news/workplace-4-0/diversity-and-inclusion/we-have-hired-differently-abled-people-into-accounts-team-and-look-to-expand-to-other-roles-manmeet-sandhu-phonepe/82116946"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>17 April</p>
                            <h2 className="itp-archive__card-container__card__title">
                                We have hired differently-abled people into
                                accounts team and look to expand to other roles:
                                Manmeet Sandhu, PhonePe
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                At a time when diversity and inclusion has
                                become a burning issue in corporates, it has
                                become ...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>ETHRWorld</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.news18.com/news/tech/phonepe-says-75-percent-of-its-coronavirus-insurance-bought-by-users-in-smaller-indian-towns-3618527.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>08 April</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe Says 75 Percent of Its Coronavirus
                                Insurance Bought by Users in Smaller Indian
                                Towns
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                PhonePe, India’s popular digital payments
                                platform, shared trends on the adoption of its
                                coronavirus insurance product on...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>News18</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.thehindubusinessline.com/money-and-banking/phonepe-captures-over-42-of-overall-upi-p2m-market-share/article34088668.ece"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>08 April</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe captures over 42% of overall UPI P2M
                                market share
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                With over 42 per cent of the UPI merchant (P2M)
                                transactions, PhonePe said it has emerged as the
                                largest player in the segment.
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Line</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.livemint.com/news/india/phonepe-becomes-first-player-to-cross-billion-transaction-mark-on-upi-11617265523373.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>01 April</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe becomes first player to cross
                                billion-transaction mark on UPI
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                Digital payments major, PhonePe on Thursday said
                                it has crossed a billion transactions on Unified
                                Payments Interface (UPI) infrastructure in
                                March...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Livemint</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.business-standard.com/article/companies/phonepe-takes-up-six-ipl-2021-sponsorships-for-its-biggest-marketing-push-121031800834_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>18 March</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe takes up six IPL 2021 sponsorships for
                                its biggest marketing push
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                PhonePe, the digital payments firm, has taken up
                                six different sponsorships for the Indian
                                Premier League (IPL) in 2021 for its...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://yourstory.com/2021/03/phonepe-launches-diversity-inclusion-charter"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>05 March</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe launches a Diversity &amp; Inclusion
                                charter to create a welcoming, safe workplace
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                PhonePe’s initial focus will be on creating
                                spaces for conversation and awareness, and to
                                review policies, processes, and systems to be
                                more inclusive.
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>YourStory</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.business-standard.com/article/companies/phonepe-leads-upi-payments-with-over-970-mn-transactions-in-february-121030200772_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>02 March</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe leads UPI payments with over 970 mn
                                transactions in February
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                The Walmart-owned firm, which competes with
                                Google Pay, Paytm and Amazon Pay, now processes
                                some 1.07 billion...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.thehindubusinessline.com/economy/logistics/tram-ticket-payments-in-kolkata-to-go-contactless/article33905885.ece"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>22 February</p>
                            <h2 className="itp-archive__card-container__card__title">
                                Tram ticket payments in Kolkata to go
                                contactless
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                Trams in Kolkata will go ‘cashless’, with
                                PhonePe – the digital payments platform
                                –providing commuters with...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Line</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.thehindubusinessline.com/money-and-banking/phonepe-partners-with-axis-bank-on-upi-multi-bank-model/article33781512.ece"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>08 February</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe partners with Axis Bank on UPI
                                multi-bank model
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                Digital payments platform PhonePe on Monday
                                announced that it has partnered with Axis Bank
                                on a Unified Payments Interface (UPI) multi-bank
                                model.
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Line</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://timesofindia.indiatimes.com/business/india-business/phonepe-gives-shares-worth-over-rs-3-lakh-to-every-employee/articleshow/80701785.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>05 February</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe gives shares worth over Rs 3 lakh to
                                every employee
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                In one of the largest employee stock ownership
                                plans (ESOP) by a startup, payments major
                                PhonePe has issued shares worth over $200
                                million or Rs 1,500 crore...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Times of India</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.livemint.com/insurance/news/phonepeicici-pru-new-term-insurance-policy-premium-starts-from-rs-149-features-benefits-11609925062715.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>07 January</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe-ICICI Pru new term insurance policy:
                                Premium starts from ₹149. Features, benefits
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                PhonePe, one of the most popular digital
                                payments platform in India, joined hands with
                                ICICI Prudential...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Livemint</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://yourstory.com/2020/12/fintech-startup-phonepe-launches-vernacular-voice-notifications-business-app"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>22 December</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe introduces vernacular voice
                                notifications on business app
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                PhonePe on Tuesday said its business app will
                                now be able to alert merchants about payments in
                                over nine...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>YourStory</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.news18.com/news/tech/phonepe-clocks-11-million-insurance-payments-heres-how-to-pay-insurance-premium-via-the-app-3186587.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>17 December</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe Clocks 11 Million Insurance Payments,
                                Here's How to Pay Insurance Premium Via The App
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                PhonePe, one of India’s leading digital payments
                                platforms has announced that it has processed...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>News18</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.thehindubusinessline.com/news/phonepe-partners-with-hyderabad-metro-to-offer-cashless-rides/article33270344.ece"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>07 December</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe partners with Hyderabad Metro to offer
                                cashless rides
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                payments platform PhonePe on Monday announced
                                that it has partnered with L&amp;T Metro Rail
                                (Hyderabad)...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Line</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.livemint.com/companies/news/phonepe-hived-off-flipkart-valued-at-5-5-billion-11606981038282.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>04 December</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe to be hived off, valued at $5.5 bn
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                Digital payments major PhonePe has been hived
                                off from parent entity, Walmart-owned...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Livemint</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://yourstory.com/2020/11/phonepe-onboards-electricity-boards-seamless-digital-payments"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>24 November</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe onboards all Indian electricity boards
                                to enable seamless bill payments
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Flipkart-owned PhonePe on Monday said it had
                                onboarded all the 73 electricity boards (both
                                public and private sector)...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>YourStory</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.business-standard.com/article/companies/phonepe-becomes-largest-platform-for-buying-digital-gold-with-35-mkt-share-120111801308_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>19 November</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe becomes largest platform for buying
                                digital gold with 35% mkt share
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Walmart-owned digital payments firm PhonePe said
                                that it has emerged as the largest platform for
                                buying 'digital gold'...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.news18.com/news/tech/phonepe-clocks-250-million-users-in-india-and-clocks-835-million-upi-transactions-in-october-3032453.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>02 November</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe Clocks 250 Million Users In India And
                                Takes 40% Share Of Record Breaking UPI
                                Transactions For October
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                India’s leading digital payments platform
                                PhonePe has now crossed the 250 million user...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>News18</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://tech.hindustantimes.com/tech/news/phonepe-is-now-available-at-over-20-lakh-stores-in-maharashtra-71604058241815.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>30 October</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe is now available at over 20 lakh stores
                                in Maharashtra
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Digital payments company PhonePe on Friday
                                announced that it is now available as a live
                                payment option at over 20 lakh shops...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Hindustan Times</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://brandequity.economictimes.indiatimes.com/news/marketing/phonepe-launches-dussehra-themed-fraud-awareness-campaign/78843429"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>24 October</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe launches Dussehra-themed fraud awareness
                                campaign
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                PhonePe, the digital payments platform, has
                                launched a new awareness building campaign
                                centered around making digital...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>ET BrandEquity</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.business-standard.com/article/companies/phonepe-dives-deeper-into-financial-services-launches-vehicle-insurance-120101400933_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>14 October</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe launches vehicle insurance service
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Walmart-owned digital payments firm PhonePe has
                                launched insurance products for private cars...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.livemint.com/news/india/phonepe-sells-5-lakh-insurance-plans-in-five-months-11601457150584.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>30 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe sells 5 lakh insurance plans in five
                                months
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Post covid-19 mobile payment apps have emerged
                                as an important platform for selling and
                                purchasing insurance plans...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Livemint</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.peoplematters.in/news/leadership/phonepe-ceo-sameer-nigam-joins-mojaloop-foundations-board-27016"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>18 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe CEO Sameer Nigam joins Mojaloop
                                Foundation's Board
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                As Sponsor members, PhonePe &amp; Ripple will
                                join the Mojaloop Foundation Board of Directors
                                and help...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>People Matters</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://timesofindia.indiatimes.com/business/india-business/best-buses-to-accept-fare-payment-using-upi/articleshow/78105993.cms?utm_source=contentofinterest&utm_medium=text&utm_campaign=cppst"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>14 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                BEST buses to accept fare payment using UPI
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Digital payments platform PhonePe has partnered
                                with Brihanmumbai Electricity Supply and
                                Transport Undertaking (BEST)...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Times of India</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.exchange4media.com/ipl-news/we-expect-audiences-in-much-greater-numbers-to-watch-ipl-this-year-richa-sharma-phonepe-107416.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>08 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                We expect audiences in much greater numbers to
                                watch IPL this year: Richa Sharma, PhonePe
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                One of the co-presenting partners in IPL 2020,
                                PhonePe has been long associated with the
                                league. Richa Sharma, Director - Brand Marketing
                                at PhonePe...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Exchange4media</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://bfsi.eletsonline.com/phonepe-to-enable-e-payments-for-over-25-million-small-merchants-in-2021-hemant-gala-vp-financial-services-payments/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>07 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe to enable over 25 mn small merchant
                                e-payments in 2021: Hemant Gala, VP Financial
                                Services &amp; Payments
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                The digital payments segment is undergoing
                                massive growth cycle due...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>BFSI</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.business-standard.com/article/companies/phonepe-to-expand-business-digitise-25-mn-small-merchants-create-10k-jobs-120083100342_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>31 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe to expand business, digitise 25 mn small
                                merchants, create 10K jobs
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Walmart-owned PhonePe, said that it will enable
                                digital payments for over 25 million...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.businesstoday.in/current/corporate/phonepe-plans-an-ipo-by-2023-sees-valuation-of-7-10-billion/story/413810.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>24 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe plans an IPO by 2023; sees valuation of
                                $7-10 billion
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                PhonePe is planning an initial public offering
                                (IPO) by 2023. The Walmart-owned digital payment
                                company headquartered...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Today</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.deccanchronicle.com/technology/in-other-news/170820/phonepe-eyes-more-users-with-five-new-insurance-products-one-mutual-f.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>17 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe eyes more users with five new insurance
                                products, one mutual fund offering
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Digital payments platform PhonePe is expanding
                                its financial services to include insurance and
                                mutual funds products...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Deccan Chronicle</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.newindianexpress.com/business/2020/aug/13/phonepe-sees-50-per-cent-growth-in-new-users-amid-covid-19-2182736.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>13 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe sees 50 percent growth in new users amid
                                COVID-19
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                The rapid adoption of digital payment platforms
                                especially for utilities, peer-to-peer
                                transactions as well as e-commerce...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The New Indian Express</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.livemint.com/industry/advertising/phonepe-celebrates-india-s-undaunted-spirit-amid-covid-19-11597309859750.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>13 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe celebrates India's undaunted spirit amid
                                COVID-19
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                With the country gradually unlocking for
                                business after a four-month lockdown, there's a
                                strong urge among Indian...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Livemint</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.moneycontrol.com/news/business/personal-finance/phonepe-icici-lombard-general-insurance-launch-health-scheme-all-you-need-to-know-5602271.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>28 July</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe partners with ICICI Lombard to offer
                                hospital daily cash benefit
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                ICICI Lombard General Insurance and PhonePe have
                                partnered to launch the Hospital Daily cash
                                benefit policy scheme...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Moneycontrol</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/ola-partners-phonepe-to-expand-payment-options-for-riders/articleshow/76833772.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>07 July</p>
                            <h2 className="itp-archive__card-container__card__title">
                                Ola partners PhonePe to expand payment options
                                for riders
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                Ride-hailing platform Ola on Tuesday said it has
                                entered into a strategic partnership with
                                Flipkart-owned PhonePe...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Economic Times</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.livemint.com/companies/news/phonepe-pilots-hyperlocal-deliveries-partners-with-shadowfax-11593948018593.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>05 July</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe partners with Shadowfax to pilot
                                hyperlocal deliveries in Bengaluru
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                Flipkart-owned PhonePe has partnered with
                                logistics firm Shadowfax to pilot hyperlocal
                                deliveries for its offline kirana merchants in
                                Bengaluru.
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Livemint</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.business-standard.com/article/companies/walmart-s-phonepe-assures-employees-there-will-be-no-layoffs-salary-cuts-120070201666_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>02 July</p>
                            <h2 className="itp-archive__card-container__card__title">
                                Walmart’s PhonePe assures employees there will
                                be no layoffs, salary cuts
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                At a time when companies are bracing for tough
                                measures to mitigate the impact of losses due to
                                the Covid-19...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.livemint.com/companies/news/phonepe-launches-new-investment-solution-super-funds-11588586877841.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>04 May</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe launches new investment solution
                                SuperFunds
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Super Funds will invest across equity, gold and
                                debt funds of mutual fund companies,
                                diversifying risk to help investors create
                                long-term wealth...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Livemint</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://yourstory.com/2020/02/phonepe-users-brand-marketing-500-million-alia-bhatt"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>14 February</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe aims to reach 500M users by 2022, sets
                                aside Rs 800 Cr for brand marketing in 2020
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                Bengaluru-based payments company PhonePe has set
                                aside Rs 800 crore for brand marketing campaigns
                                in 2020
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>YourStory</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.business-standard.com/article/companies/phonepe-to-create-world-s-biggest-atm-network-of-2-mn-in-india-by-year-end-120020700282_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>08 February</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe to create world's biggest ATM network of
                                2 mn in India by year end
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                PhonePe says it will by the end of this year
                                create an Automated Teller Machine (ATM) network
                                of 2 million, helping
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://gadgets.ndtv.com/apps/news/phonepe-chat-feature-launched-android-ios-2174034"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>03 February</p>

                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe Introduces Chat Feature on Android, iOS
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                In a bid to make it easier for users to have a
                                conversation on the platform, digital payments
                                player...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Gadgets 360</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://www.businesstoday.in/opinion/interviews/walmart-is-optimistic-about-our-potential-size-says-phonepe-ceo-sameer-nigam/story/384890.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>15 October</p>

                            <h2 className="itp-archive__card-container__card__title">
                                Walmart is optimistic about our potential size,
                                says PhonePe CEO Sameer Nigam
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                Walmart is now looking at us differently in
                                terms of our potential size and opportunities as
                                to how we may work with them...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Today</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://yourstory.com/2019/10/techsparks-2019-phonepe-sameer-nigam-payments-startup"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>13 October</p>
                            <h2 className="itp-archive__card-container__card__title">
                                TechSparks 2019: An open payments ecosystem is
                                the key to achieving our vision, says PhonePe’s
                                Sameer Nigam
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                PhonePe’s vision is to build an open ecosystem,
                                to push the boundaries...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>YourStory</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://yourstory.com/2019/09/phonepe-in-app-platform-switch-upi-digital-payments"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>19 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                Here’s why PhonePe rebranded its in-app platform
                                to 'PhonePe Switch'
                            </h2>
                            <p className="itp-archive__card-container__card__subtext">
                                PhonePe Switch allows customers to seamlessly
                                switch between PhonePe and their favourite food,
                                grocery, shopping and ...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>YourStory</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://economictimes.indiatimes.com/markets/ipos/fpos/flipkart-owned-phonepe-first-non-bank-to-enable-upi-based-ipo-bidding/articleshow/71172949.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>17 September</p>
                            <h2 className="itp-archive__card-container__card__title">
                                Flipkart-owned PhonePe first non-bank to enable
                                UPI-based IPO bidding
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                PhonePe is the first non-bank company to
                                facilitate UPI-based IPO bidding since the
                                capital markets regulator Sebi and payments
                                governance...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Economic Times</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.business-standard.com/article/companies/phonepe-s-journey-to-become-one-of-the-most-valuable-startups-119090600682_1.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>07 September</p>

                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe's journey to becoming one of the most
                                valuable startups
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                PhonePe, the payments business of the
                                Walmart-Flipkart group, has received yet another
                                validation, this time from financial services
                                major Morgan...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Standard</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://cio.economictimes.indiatimes.com/news/strategy-and-management/heres-how-flipkart-backed-phonepe-is-using-ml-to-redefine-payment-experience/70903243"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>30 August</p>

                            <h2 className="itp-archive__card-container__card__title">
                                Here’s how Flipkart backed PhonePe is using ML
                                to redefine payment experience
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                In terms of personalized user experience, we use
                                a combination of data driven nudges and user
                                preferences. Our machine learning model
                                learns...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>ETCIO</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card card-two">
                        <a
                            href="https://economictimes.indiatimes.com/small-biz/startups/newsbuzz/how-flipkarts-phonepe-plans-to-become-a-major-financial-services-player/articleshow/70821764.cms"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>25 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                How Flipkart's PhonePe plans to become a major
                                financial services player
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                The next stage of PhonePe’s evolution will see
                                the company evolve into becoming a broader
                                financial services player. “We will get into
                                mutual funds...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>The Economic Times</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.livemint.com/companies/company-results/phonepe-clocks-335-mn-transactions-in-july-hits-95-bn-annual-tpv-run-rate-1564751041962.html"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>02 August</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe clocks 335 mn transactions in July, hits
                                $95 bn annual TPV run rate
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                PhonePe's TPV run rate has grown nearly 5X in
                                the past year, since crossing the $20 billion...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Livemint</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div className="itp-archive__card-container">
                    <div className="itp-archive__card-container__card">
                        <a
                            href="https://www.thehindubusinessline.com/info-tech/phonepe-eyes-offline-merchant-base-of-7-million-by-year-end/article26029800.ece"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <p>18 January</p>
                            <h2 className="itp-archive__card-container__card__title">
                                PhonePe eyes offline merchant base of 7 million
                                by year-end
                            </h2>
                            <p className="itp-archive__card-container__card__subtext ">
                                “Ever since we started onboarding offline
                                merchants in a P2P (peer-to-peer) payments mode
                                — which allows the transfer of payment from a
                                consumer’s bank...
                            </p>
                            <div className="itp-archive__card-container__card__el-wrapper">
                                <div className="itp-archive__card-container__card__el-wrapper__pointer-el">
                                    <div>
                                        <span>Business Line</span>
                                    </div>
                                    <div>
                                        <span className="arrow-el">
                                            &#8594;
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="itp-archive__card-container__card coming-soon"></div>
                    <div className="itp-archive__card-container__card coming-soon"></div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default InThePressArchives;
